export const eventPaid = 'Paid';
export const eventFunded = 'Funded';
export const eventNotFunded = 'Not funded';
export const MINUTES_FOR_UNSYNC = 120;
